import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.ts';
import './SiteHeader.css';

/**
 * Global marketing header. Rendered on the public surfaces (home, legal) —
 * App suppresses it on routes that own their chrome (the console,
 * /auth/*, /app). Auth controls are driven by `useAuth().status`:
 *   - unauthenticated → Sign in / Sign up
 *   - authenticated   → Console / Sign out
 *   - initializing    → brand mark only (avoids a flash of the wrong buttons)
 */
export default function SiteHeader() {
  const { status, signOut } = useAuth();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  async function handleSignOut() {
    setSigningOut(true);
    try {
      await signOut();
    } finally {
      setSigningOut(false);
    }
    navigate('/auth/signed-out', { replace: true });
  }

  return (
    <header className="om-site-header">
      <div className="om-site-header__inner">
        <Link to="/" className="om-site-header__brand" aria-label="OculusMind.AI home">
          Oculus<span className="om-site-header__brand-accent">Mind</span>.AI
        </Link>

        {status === 'authenticated' ? (
          <nav className="om-site-header__nav" aria-label="Account">
            {/* Plain <a>, NOT <Link>: /widgets is static HTML served from the
                widgets bucket, not an SPA route. A router Link would intercept
                the click, match no route, and hit App's catch-all — which
                redirects to "/". The reader would land back on the homepage. */}
            <a href="/widgets" className="om-site-header__link">
              Briefs
            </a>
            <span className="om-site-header__divider" aria-hidden="true" />
            <Link to="/integrations" className="om-site-header__link">
              API
            </Link>
            <span className="om-site-header__divider" aria-hidden="true" />
            <Link to="/app" className="om-site-header__link">
              Console
            </Link>
            <button
              type="button"
              className="om-site-header__btn"
              onClick={() => {
                void handleSignOut();
              }}
              disabled={signingOut}
            >
              {signingOut ? 'Signing out…' : 'Sign out'}
            </button>
          </nav>
        ) : status === 'unauthenticated' ? (
          <nav className="om-site-header__nav" aria-label="Authentication">
            {/* Plain <a>, NOT <Link>: /widgets is static HTML served from the
                widgets bucket, not an SPA route. A router Link would intercept
                the click, match no route, and hit App's catch-all — which
                redirects to "/". The reader would land back on the homepage. */}
            <a href="/widgets" className="om-site-header__link">
              Briefs
            </a>
            <span className="om-site-header__divider" aria-hidden="true" />
            <Link to="/integrations" className="om-site-header__link">
              API
            </Link>
            <span className="om-site-header__divider" aria-hidden="true" />
            <Link to="/auth/signin" className="om-site-header__link">
              Sign in
            </Link>
            <Link to="/auth/signup" className="om-site-header__btn">
              Sign up
            </Link>
          </nav>
        ) : null}
      </div>
    </header>
  );
}
